<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <user-activities-page />
    </div>
  </div>
</template>

<script>
import UserActivitiesPage from '../Components/UserActivitiesPage.vue';
export default {
  name: 'UserActivities',
  components: {
    'user-activities-page': UserActivitiesPage,
  },
};
</script>

<style scoped></style>
